var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        [
          _c(
            "w-row",
            { attrs: { grow: "" } },
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel mr",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
              ),
              _vm.canEdit
                ? _c(
                    "w-button",
                    {
                      attrs: { icon: "pen" },
                      on: {
                        click: function ($event) {
                          return _vm.edit()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.edit")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        {
          style: { paddingTop: "0", height: "100%" },
          attrs: { tag: "w-container", grow: "" },
        },
        [
          _c(
            "transition",
            { attrs: { name: "fast-fade", mode: "out-in" } },
            [
              _vm.currentTabKey == "general"
                ? _c("app-project-info-general", {
                    attrs: {
                      project: _vm.project,
                      lg: "12",
                      md: "12",
                      xs: "12",
                    },
                  })
                : _vm.currentTabKey == "extra-fields"
                ? _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "12", md: "12" } },
                    [
                      _c("app-project-edit-extra-fields", {
                        attrs: { value: _vm.project.ExtraFields, readonly: "" },
                      }),
                    ],
                    1
                  )
                : _vm.currentTabKey == "documents"
                ? _c("app-project-info-aws-documents", {
                    attrs: { project: _vm.project },
                  })
                : _vm.activeTab < _vm.extraFieldTabStart
                ? _c("app-custom-view-tab-frames", {
                    attrs: {
                      model: _vm.project,
                      tab: _vm.activeTab,
                      "start-tab-index": _vm.defaultTabs.length,
                      tabs: _vm.customViewTabs,
                    },
                    on: {
                      "update-parent": function ($event) {
                        return _vm.onUpdateParent($event)
                      },
                    },
                  })
                : _c("app-extra-field-tab", {
                    key: "extra-field-" + _vm.activeTab,
                    attrs: {
                      value: _vm.project.ExtraFields,
                      tab: _vm.extraFieldTabs[
                        _vm.activeTab - _vm.extraFieldTabStart
                      ],
                      "name-settings": _vm.extraFieldNamesConfig,
                      readonly: "",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }